var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "identify-viewer" }, [
    _vm.emptyPage
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "alert alert-primary", attrs: { role: "alert" } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(`${_vm.idPanel}.result.no_data`)) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ])
      : _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "identify-view-container" }, [
              _c(
                "div",
                {
                  staticClass: "identify-slider-view",
                  class: _vm.containerClass,
                },
                _vm._l(_vm.validResponses, function (res, idx) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.index == idx,
                          expression: "index==idx",
                        },
                      ],
                      key: `identify-view-${idx}`,
                      staticClass: "panel panel-default",
                    },
                    [
                      _c("div", { staticClass: "panel-body" }, [
                        _c(
                          "div",
                          { staticClass: "w-100 h-100 overflowX" },
                          [
                            _c(_vm.viewer(res), {
                              tag: "component",
                              attrs: {
                                response: res.response,
                                layer: res.layerMetadata,
                                activeItemId: _vm.activeItemId,
                              },
                              on: { close: _vm.onCloseViewer },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.emptyLayers
                ? _c("div", { staticClass: "row small mt-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", {
                        staticClass: "alert alert-info mb-0",
                        attrs: { role: "alert" },
                        domProps: { innerHTML: _vm._s(_vm.emptyLayers) },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.exceptionLayers
                ? _c("div", { staticClass: "row small mt-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", {
                        staticClass: "alert alert-danger mb-0",
                        attrs: { role: "alert" },
                        domProps: { innerHTML: _vm._s(_vm.exceptionLayers) },
                      }),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }